module.exports = __webpack_public_path__ + "img/bg.fa6c174d.jpg";